import React, { useState, useEffect } from "react";
import CustomButton from "../../../components/AddButton";
import { edit, Plus, map, placeMareker } from "../../../common/svg";
import { Expenses, FuelExpenses } from "../../../common/staticData";
import CustomCard from "../../../components/Card";
import DaysLeftCounter from "../../../components/DaysProgress";
import CustomChip from "../../../components/Chip";
import SecureImage from "../../../components/BucketImage/Image";
import DeliveryTimeline from "../../../components/DeliveryTimeline";
import { fuel } from "../../../common/svg";
import ContainerVehicleDetails from "../../Booking/view/container";
import PhotoGrid from "../../../components/ImageView";

type Props = {
  images: string[];
};

const Routes: React.FC<Props> = ({ images }) => {
  // Separate state for each card section
  const [activeExpenseCard, setActiveExpenseCard] = useState<number | null>(null);
  const [activeFuelCard, setActiveFuelCard] = useState<number | null>(null);
  const [viewTripDetails, setViewTripDetails] = useState<boolean>(false);
  const [isWhite, setIsWhite] = useState(false);

  useEffect(() => {
    const handleClick = () => setIsWhite(true);
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  const handleClick = () => {
    console.log("Button clicked!");
  };

  // Updated handler to specify which section the card belongs to
  const handleViewExpenseDetails = (index: number) => {
    setActiveExpenseCard(index);
    setActiveFuelCard(null); // Reset other section's active card
    setViewTripDetails(true);
  };

  // New handler for fuel expense cards
  const handleViewFuelDetails = (index: number) => {
    setActiveFuelCard(index);
    setActiveExpenseCard(null); // Reset other section's active card
    setViewTripDetails(true);
  };

  const [isEditing, setIsEditing] = useState(false);
  const [routeInfo, setRouteInfo] = useState({
    code: "EN14245",
    start: "Chennai Manali Yard",
    end: "Ennore Port",
  });

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const parts = value.split(" – "); // Split input by " – "

    if (parts.length === 3) {
      setRouteInfo({
        code: parts[0],
        start: parts[1],
        end: parts[2],
      });
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  return (
    <div>
      <div className="bg-white p-2 mt-3 rounded-[20px]">
        <div className="flex justify-between border-b border-[#C1C1C1] border-dashed p-2">
          <p className="text-[#444FBD] text-[16px] font-[600]">
            Documents (03)
          </p>
          <CustomButton label="" icon={Plus} onClick={handleClick} />
        </div>
        <br />
        <div className="flex gap-2 mt-">
          {/* Left */}
          <div>
            {Expenses.map((booking, index) => (
              <CustomCard
                key={`expense-${index}`}
                onClick={() => handleViewExpenseDetails(index)}
                isActive={activeExpenseCard === index}
                className="w-[400px] shadow-[1px_-1px_3.6px_2px_#00000033] p-2 rounded"
              >
                <div className="gap-[-1]">
                  {/* Top Section: Booking Name and Trip Status */}
                  <div className="flex justify-between items-center ">
                    <div className="flex items-center space-x-2">
                      <p className="font-Poppins">{booking.Trip}</p>
                    </div>
                    {/* <p className=" font-[400] text-[14px]">#0{index + 1}</p> */}
                  </div>
                  {/* Booking Details */}
                  <div className="flex justify-between">
                    <div className="leading-[18px] felx flex-col items-start">
                      <span>{booking.bookingId}</span>
                      <p className="text-[14px]">{booking.bookingDate}</p>
                    </div>
                    <div className="font-Poppins">
                      <p className="text-[15px]  font-[300]">
                        Total Amount
                      </p>
                      <p className="text-[20px] font-[600]">
                        ₹ 132,000
                      </p>
                    </div>
                  </div>

                  {/* Client Name with Conditional Styling */}
                  <div className="flex justify-between items-end">
                    <div className="flex flex-col leading-[15px]">
                      <p
                        className={`font-medium text-[14px] ${
                          activeExpenseCard === index ? "text-[# ]" : "text-[# ]"
                        }`}
                      ></p>
                    </div>
                  </div>
                </div>
              </CustomCard>
            ))}
          </div>
          {viewTripDetails && (
            <div className="mt-[-20px] w-full border-l border-[#C1C1C1] border-dashed">
              {viewTripDetails && (
                <div className="flex flex-col w-full">
                  <div className="flex flex-col gap-4">
                    <div className="w-full">
                      <div className="flex justify-between items-start w-full">
                        <div className="flex items-center ">
                          <SecureImage
                            fileKey={fuel}
                            alt="header icon"
                            width="45px"
                            className="ml-4 mt-4"
                          />
                          <p className="text-[20px] text-[#282828] font-[600] font-Poppins ml-3">
                            Fuel Expenses
                          </p>
                        </div>

                        <div className="flex flex-col ml-10">
                          <div className="flex items-center gap-2">
                            {/* Label */}
                            <p className="text-[15px] text-[#282828] font-[300] font-Poppins">
                              Total Amount
                            </p>
                            <CustomButton
                              label=""
                              icon={edit}
                              onClick={handleEditClick}
                            />
                          </div>
                          {/* Value + Button */}
                          <div className="flex items-center gap-2 mt-1">
                            <p className="text-[20px] text-[#444FBD] font-[600] font-Poppins">
                               ₹ 132,000
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="ml-6 flex items-center gap-2">
                        <p className="text-[16px] text-[#282828] font-[400] font-Poppins ml-12">
                          No of Transactions
                        </p>
                        <p className="text-[16px] text-[#282828] font-[400] font-Poppins ml-5">
                          25
                        </p>
                      </div>
                      <div className="border-b border-[#C1C1C1] border-dashed p-2"></div>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 mt-5 ">
                    <div className="flex flex-wrap gap-4">
                      {/* Unsettled Amount */}
                      <div className="w-[300px] h-[74px] rounded-[20px] border border-[#FF9788] bg-[#FFECE9] px-4 py-2 flex flex-col justify-between">
                        <div className="flex items-center justify-between">
                          <p className="text-[16px] text-[#282828] font-[400] font-Poppins">
                            Unsettled Amount
                          </p>
                          <p className="text-[16px] font-Poppins font-[600]">
                            ₹ 1,32,000
                          </p>
                        </div>
                        <p className="italic text-sm text-[#555]">
                          No of Transactions{" "}
                          <span className="not-italic font-Poppins ml-1 font-[600]">
                            45 Nos
                          </span>
                        </p>
                      </div>

                      {/* Overdue Amount */}
                      <div className="w-[300px] h-[74px] rounded-[20px] border border-[#FFD4AD] bg-[#FFF1E4] px-4 py-2 flex flex-col justify-between">
                        <div className="flex items-center justify-between">
                          <p className="text-[16px] text-[#282828] font-[400] font-Poppins">
                            Over due Amount
                          </p>
                          <p className="text-[16px] font-Poppins font-[600]">
                            ₹ 1,32,000
                          </p>
                        </div>
                        <p className="italic text-sm text-[#555]">
                          No of Transactions{" "}
                          <span className="not-italic font-Poppins ml-1 font-[600]">
                            45 Nos
                          </span>
                        </p>
                      </div>

                      {/* Settled Amount */}
                      <div className="w-[300px] h-[74px] rounded-[20px] border border-[#22DE1E] bg-[#ECFFEB] px-4 py-2 flex flex-col justify-between">
                        <div className="flex items-center justify-between">
                          <p className="text-[16px] text-[#282828] font-[400] font-Poppins">
                            settled Amount
                          </p>
                          <p className="text-[16px] font-Poppins font-[600]">
                            ₹ 1,32,000
                          </p>
                        </div>
                        <p className="italic text-[14px] text-[#282828] font-[400] font-Poppins">
                          No of Transactions{" "}
                          <span className="not-italic font-Poppins ml-1 font-[600]">
                            45 Nos
                          </span>
                        </p>
                      </div>

                      {/* Fuel Expenses */}
                      <div className="grid grid-cols-2 gap-4">
                        {FuelExpenses.map((booking, index) => (
                          <CustomCard
                            key={`fuel-${index}`}
                            onClick={() => handleViewFuelDetails(index)}
                            isActive={activeFuelCard === index}
                            className="w-[400px] shadow-[1px_-1px_3.6px_2px_#00000033] p-4 rounded"
                          >
                            <div className="flex flex-col justify-between h-full gap-4">
                              {/* Top Section: 1 & 2 */}
                              <div className="flex flex-col gap-2">
                                {/* 1. Trip Name and ID */}
                                <div className="flex justify-between items-center">
                                  <p className="font-Poppins">{booking.Trip}</p>
                                  <CustomChip
                                    text={booking.tripStatus}
                                    textColor="#04D900"
                                    borderColor="#04D900" 
                                  />
                                  <p className="font-[400] text-[14px]">#0{index + 1}</p>
                                </div>

                                {/* 2. Booking ID and Date */}
                                <div className="flex justify-between">
                                  <div className="leading-[18px] flex flex-col items-start">
                                    <span>{booking.bookingId}</span>
                                    <p className="text-[14px]">{booking.bookingDate}</p>
                                    <PhotoGrid images={booking.images || []} />
                                  </div>
                                  <div className="font-Poppins text-right">
                                    <p className="text-[20px] font-[600]">₹ 132,000</p>
                                    <p className="text-[15px] font-[300]">30 July 2024, 06:16pm</p>
                                  </div>
                                </div>
                              </div>

                              {/* Bottom Section: 3 & 4 */}
                              <div className="flex justify-between items-end">
                                <div className="flex flex-col leading-[15px]">
                                  <p
                                    className={`font-medium text-[14px] ${
                                      activeFuelCard === index ? "text-[#000]" : "text-[#000]"
                                    }`}
                                  >
                                    {/* {booking.clientName} */}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </CustomCard>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Routes;